import React, { useState, useEffect, useRef } from "react";

import {
  Content,
  FormFiltro,
  Linha,
  LinhaTags,
  SelectCurso,
  SelectArea,
  Button,
  StyledTag,
  ContainerAno,
  Quantidade,
  AnimatedDone,
  ContainerDone,
  ContentEnviando,
  Dicas,
  ButtonLink,
} from "./styles";

import { Container } from "../../../styles/GlobalStyles";

import Header from "../../../components/Header";
import Modal from "../../../components/Modal";
import InputRadio from "../../../components/InputRadio";
import { useHistory, useLocation } from "react-router-dom";
import { api } from "../../../services/api";
import Select from "../../../components/Select";
import Lottie from "react-lottie";
import animationData from "../../../assets/sentanim.json";
import Alerts from "../../../components/Alerts";
import SpinnerLoading from "../../../components/SpinnerLoading";
import { FaInfoCircle } from "react-icons/fa";
import InputCheckbox from "../../../components/InputCheckbox";

function BuscarAlunos() {
  const history = useHistory();
  const location = useLocation();

  let vaga = null;

  if (location.state) vaga = location.state.vaga;

  const defaultOptions = {
    loop: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const headerLinks = [{ label: "Sair", to: "/" }];

  const [loading, setLoading] = useState(false);
  const [concluido, setConcluido] = useState(false);

  const [qtdAlunos, setQtdAlunos] = useState(-1);

  const [cursos, setCursos] = useState([]);
  const [cursosSel, setCursosSel] = useState([]);

  const [areas, setAreas] = useState([]);
  const [areaSel, setAreaSel] = useState({});

  const [cidades, setCidades] = useState([]);
  const [cidadesSel, setCidadesSel] = useState([]);

  const [filtros, setFiltros] = useState({});
  const [anoFim, setAnoFim] = useState(new Date().getFullYear());
  const [anoInicio, setAnoInicio] = useState(2007);

  const [idadeFim, setIdadeFim] = useState(99);
  const [idadeInicio, setIdadeInicio] = useState(15);

  const [mensagem, setMensagem] = useState(undefined);
  const [loadingCampos, setLoadingCampos] = useState(false);

  const [showModalCursos, setShowModalCursos] = useState(false);

  const selCursoRef = useRef();
  const selAreaRef = useRef();
  const selCidadesRef = useRef();

  useEffect(() => {
    carregarAreas();
  }, []);

  const getCursosSel = () => cursos.filter((c) => c.isChecked);

  const getCursosUnsel = () => cursos.filter((c) => !c.isChecked);

  /**
   * Contar alunos pelo filtro
   */
  useEffect(() => {
    const contarAlunos = async () => {
      if (!vaga) return;

      setLoadingCampos(true);

      let cursos_id = cursosSel.map((c) => c.id);

      let cursos_ids_excluidos = getCursosUnsel().map((c) => c.value);

      let cidades = cidadesSel.map((c) => c.municipio);

      let { anoInicio } = filtros;
      let anoFim = anoInicio && !filtros.anoFim ? new Date().getFullYear() : filtros.anoFim;

      let { idadeInicio } = filtros;
      let idadeFim = idadeInicio && !filtros.idadeFim ? 99 : filtros.idadeFim;

      let { sexo } = filtros;
      let { pcd } = filtros;

      let { concluido } = filtros;

      try {
        const retorno = await api.get(`vagas/${vaga.id}/alunos-filtro`, {
          params: {
            area_id: areaSel.id,
            cursos_ids_excluidos,
            cidades: cidades,
            ano_inicio: anoInicio,
            ano_fim: anoFim,
            idade_inicio: idadeInicio,
            idade_fim: idadeFim,
            sexo,
            pcd,
            concluido,
          },
        });

        setQtdAlunos(retorno.data.qtd_alunos);

        setLoadingCampos(false);
      } catch (e) {
        console.log(e);
        setLoadingCampos(false);
      }
    };

    setLoading(true);

    if (areaSel.id) {
      contarAlunos();
    } else {
      setQtdAlunos(-1);
    }

    setLoading(false);
  }, [cidadesSel, cursos, vaga, filtros]);

  /**
   * Troca label das cidades
   */
  useEffect(() => {
    if (vaga && cidadesSel.length === 0) {
      if (selCidadesRef.current) {
        selCidadesRef.current[0].text = "Todas";
      }
    }
  }, [cidadesSel]);

  /**
   * Carregar cidades pela area selecionada
   */
  useEffect(() => {
    const carregarCidades = async () => {
      setLoadingCampos(true);

      try {
        const retorno = await api.get(`/filtros/cidades`, {
          params: { id_area: areaSel.id },
        });

        setCidades(retorno.data);

        setLoadingCampos(false);
      } catch (e) {
        setLoadingCampos(false);

        console.log(e);
      }
    };

    if (areaSel.id) {
      setCidadesSel([]);
      setCidades([]);
      carregarCidades();
    } else {
      setCidadesSel([]);
    }
  }, [areaSel]);

  /**
   * Carregar cursos pela area selecionada
   */
  useEffect(() => {
    const carregarCursos = async () => {
      // setCursos([]);
      // setCursosSel([]);
      setLoadingCampos(true);

      try {
        const retorno = await api.get(`/filtros/areas/${areaSel.id}/cursos`);

        setCursos(
          retorno.data.map((c) => ({
            value: c.id,
            label: `${c.nome} - CH: ${c.carga_horaria}`,
            isChecked: true,
          }))
        );

        setLoadingCampos(false);
      } catch (e) {
        setLoadingCampos(false);

        console.log(e);
      }
    };

    if (areaSel.id) {
      carregarCursos();
    }
  }, [areaSel]);

  const carregarAreas = async () => {
    if (!vaga) return;

    setLoadingCampos(true);

    try {
      const retorno = await api.get("/filtros/areas");

      setAreas(retorno.data);
      setLoadingCampos(false);
    } catch (e) {
      setLoadingCampos(false);

      console.error(e);
    }
  };

  const handlerArea = (e) => {
    const area = areas.find((a) => a.id.toString() === e.target.value);
    setAreaSel(area ? area : {});
    const { options } = selAreaRef.current;

    for (var i = 0; i < options.length; i++) {
      options[i].disabled = false;
    }
    var index = e.target.selectedIndex;
    e.target[index].disabled = true;
  };

  const handlerCidades = (e) => {
    const cidade = cidades.find((c) => c.municipio === e.target.value);

    setCidadesSel([...cidadesSel, cidade]);

    var index = e.target.selectedIndex;
    e.target[index].disabled = true;

    e.target[0].text = "Selecione";
  };

  const unSelCidade = (cidade) => {
    let cidadeCopy = cidadesSel.slice();

    cidadeCopy.splice(cidadeCopy.indexOf(cidade), 1);

    setCidadesSel(cidadeCopy);

    const { options } = selCidadesRef.current;

    for (var i = 0; i < options.length; i++) {
      if (options[i].value === cidade.municipio) options[i].disabled = false;
    }
  };

  const handlerAnoInicio = (e) => {
    if (e.target.value.length === 4) {
      if (anoFim && e.target.value > anoFim) return setAnoInicio("");
      setAnoFim(new Date().getFullYear());
      setFiltros({ ...filtros, anoInicio: e.target.value });
    }
    setAnoInicio(e.target.value);
  };

  const handlerAnoFim = (e) => {
    if (e.target.value.length === 4) {
      if (e.target.value < anoInicio) return setAnoFim("");
      setFiltros({ ...filtros, anoFim: e.target.value });
    }
    setAnoFim(e.target.value);
  };

  const handlerIdadeInicio = (e) => {
    if (e.target.value.length === 2) {
      if (idadeFim && e.target.value > idadeFim) return setIdadeInicio("");
      !idadeFim && setIdadeFim(99);
      setFiltros({ ...filtros, idadeInicio: e.target.value });
    }
    setIdadeInicio(e.target.value);
  };

  const handlerIdadeFim = (e) => {
    if (e.target.value.length === 2) {
      if (e.target.value < idadeInicio) return setIdadeFim("");
      setFiltros({ ...filtros, idadeFim: e.target.value });
    }
    setIdadeFim(e.target.value);
  };

  const handlerSituacaoCurso = (e) => {
    const concluido = e.target.value;
    setFiltros({
      ...filtros,
      concluido: concluido === "0" ? undefined : e.target.value,
      anoInicio: concluido === "N" ? undefined : anoInicio,
      anoFim: concluido === "N" ? undefined : anoFim,
    });
    if (concluido === "N") {
      setAnoFim("");
      setAnoInicio("");
    }
  };

  const handlerSexo = (e) => {
    setFiltros({
      ...filtros,
      sexo: e.target.value === "0" ? undefined : e.target.value,
    });
  };

  const handlerPcd = (e) => {
    setFiltros({
      ...filtros,
      pcd: e.target.value === "0" ? undefined : e.target.value,
    });
  };

  const handlerCheckCurso = (e) => {
    setCursos(
      cursos.map((c) =>
        c.value == e.target.value ? { ...c, isChecked: e.target.checked } : c
      )
    );
  };

  const handlerTodosCursos = (e) => {
    if (getCursosSel().length === cursos.length) {
      setCursos(cursos.map((c) => ({ ...c, isChecked: false })));
    } else {
      setCursos(cursos.map((c) => ({ ...c, isChecked: true })));
    }
  };

  useEffect(() => console.log(cursos), [cursos]);

  const enviar = async (e) => {
    e.preventDefault();

    setLoading(true);
    setConcluido(true);

    let cursos_ids_excluidos = getCursosUnsel().map((c) => c.value);

    let cidades = cidadesSel.map((c) => c.municipio);

    let { anoInicio } = filtros;
    let anoFim = anoInicio && !filtros.anoFim ? new Date().getFullYear() : filtros.anoFim;

    let { idadeInicio } = filtros;
    let idadeFim = idadeInicio && !filtros.idadeFim ? 99 : filtros.idadeFim;

    let { sexo } = filtros;
    let { pcd } = filtros;

    try {
      await api.post(`vagas/${vaga.id}/alunos-filtro`, null, {
        params: {
          area_id: areaSel.id,
          cursos_ids_excluidos,
          cidades: cidades,
          ano_inicio: anoInicio,
          ano_fim: anoFim,
          idade_inicio: idadeInicio,
          idade_fim: idadeFim,
          sexo,
          pcd,
        },
      });

      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Container>
      {!vaga ? (
        "Acesso negado!"
      ) : (
        <>
          <Alerts mensagem={mensagem} setMensagem={setMensagem} tipo="erro" />
          {showModalCursos && (
            <Modal
              title="Cursos Selecionadas"
              handleClose={() => setShowModalCursos(false)}
            >
              <div
                style={{
                  width: "80vw",
                  maxHeight: "80vh",
                  marginTop: 10,
                  paddingBottom: 10,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <InputCheckbox
                  id="selecionar-todos"
                  value="todos"
                  label={"Selecionar todos"}
                  isChecked={getCursosSel().length === cursos.length}
                  handler={handlerTodosCursos}
                />
                <br />
                {cursos.map((c) => (
                  <InputCheckbox
                    id="cursos"
                    value={c.value}
                    isChecked={c.isChecked}
                    label={c.label}
                    handler={handlerCheckCurso}
                  />
                ))}
                <button
                  style={{
                    alignSelf: "center",
                    width: "30%",
                  }}
                  onClick={() => setShowModalCursos(false)}
                >
                  Ok
                </button>
              </div>
            </Modal>
          )}
          <Header links={headerLinks} theme="black" />
          {!concluido ? (
            <Content>
              <header>
                <h2>
                  Aplique os filtros para encontrar os alunos ideais para sua
                  vaga.
                </h2>
                {loadingCampos && (
                  <span style={{ position: "absolute", top: 0, left: 60 }}>
                    <SpinnerLoading style={{ width: 20, height: 20 }} />
                  </span>
                )}
              </header>

              <FormFiltro>
                <Linha>
                  <SelectArea
                    label="Área"
                    id="area"
                    ref={selAreaRef}
                    value={areaSel.id}
                    handler={handlerArea}
                    mensagemErro={!areaSel.id && "Selecione uma area"}
                  >
                    <option value="">Selecione</option>
                    {areas.map((a, i) => (
                      <option key={i} value={a.id}>
                        {a.descricao}
                      </option>
                    ))}
                  </SelectArea>
                </Linha>

                {Object.keys(areaSel).length > 0 && (
                  <>
                    <Linha
                      style={{
                        marginBottom: 10,
                        paddingLeft: 10,
                        marginTop: -10,
                      }}
                    >
                      {getCursosSel().length === 0 ? (
                        <span style={{ color: "var(--primary)" }}>
                          Você precisa selecionar ao menos um curso
                        </span>
                      ) : getCursosSel().length === cursos.length ? (
                        <span style={{ color: "var(--green)" }}>
                          Todos os cursos dessa área
                        </span>
                      ) : (
                        <span style={{ color: "var(--blue)" }}>
                          Alguns cursos dessa área
                        </span>
                      )}
                      &nbsp;-
                      <ButtonLink
                        type="button"
                        onClick={() => setShowModalCursos(true)}
                        style={{ fontSize: 14 }}
                      >
                        &nbsp;Editar
                      </ButtonLink>
                    </Linha>
                    <InputRadio
                      label="Situação nos cursos"
                      id="concluido"
                      handler={handlerSituacaoCurso}
                      options={[
                        { value: "S", id: "concluidoSim", label: "Concluído" },
                        { value: "N", id: "concluidoNao", label: "Cursando" },
                        {
                          value: "0",
                          id: "concluidoInd",
                          label: "Indiferente",
                          default: true,
                        },
                      ]}
                    />
                    <ContainerAno>
                      {filtros.concluido !== "N" ? (
                        <>
                          <span>Concluído entre</span>
                          <input
                            type="text"
                            id="anoInicio"
                            placeholder="2007"
                            maxLength="4"
                            minLength="4"
                            value={anoInicio}
                            onChange={handlerAnoInicio}
                          />
                          <span>e</span>
                          <input
                            type="text"
                            id="anoFim"
                            placeholder={new Date().getFullYear()}
                            maxLength="4"
                            minLength="4"
                            value={anoFim}
                            onChange={handlerAnoFim}
                          />
                        </>
                      ) : (
                        ""
                      )}
                    </ContainerAno>
                    <ContainerAno>
                      <span>Idade entre</span>
                      <input
                        type="text"
                        maxLength="2"
                        id="idadeInicio"
                        value={idadeInicio}
                        onChange={handlerIdadeInicio}
                        placeholder="18"
                      />
                      <span>e</span>
                      <input
                        type="text"
                        id="idadeFim"
                        value={idadeFim}
                        onChange={handlerIdadeFim}
                        placeholder="25"
                      />
                    </ContainerAno>
                    <Select
                      label="Cidades"
                      id="municipio"
                      ref={selCidadesRef}
                      value=""
                      handler={handlerCidades}
                    >
                      <option value="">Todas</option>
                      {cidades.map((c) => (
                        <option key={c.municipio} value={c.municipio}>
                          {c.municipio}
                        </option>
                      ))}
                    </Select>
                    <Linha>
                      {cidadesSel.length > 0 && (
                        <>
                          <strong>Cidades Selecionadas:</strong>
                          {cidadesSel.map((c) => (
                            <TagMunicipio
                              key={c.municipio}
                              obj={c}
                              handlerClose={unSelCidade}
                            />
                          ))}
                        </>
                      )}
                    </Linha>
                    <InputRadio
                      label="Sexo"
                      id="sexo"
                      handler={handlerSexo}
                      options={[
                        { value: "M", id: "sexoM", label: "Masculino" },
                        { value: "F", id: "sexoF", label: "Feminino" },
                        {
                          value: "0",
                          id: "sexoI",
                          label: "Indiferente",
                          default: true,
                        },
                      ]}
                    />
                    <InputRadio
                      type="checkbox"
                      label="PCD?"
                      id="pcd"
                      handler={handlerPcd}
                      options={[
                        { value: "S", id: "pcdS", label: "Sim" },
                        { value: "N", id: "pcdN", label: "Não" },
                        {
                          value: "0",
                          id: "pcdI",
                          label: "Indiferente",
                          default: true,
                        },
                      ]}
                    />
                  </>
                )}
                {qtdAlunos !== -1 && areaSel.id && (
                  <Quantidade>
                    <p>
                      <em>{qtdAlunos}</em> alunos alcançados.
                    </p>
                    <Button
                      direction="right"
                      color="green"
                      type="button"
                      disabled={!areaSel.id || qtdAlunos === 0}
                      onClick={enviar}
                    >
                      Enviar Vaga aos Alunos
                    </Button>
                  </Quantidade>
                )}
              </FormFiltro>
            </Content>
          ) : (
            <ContentEnviando enviando={loading}>
              <header>
                <h2>{loading ? "Enviando..." : "Tudo certo!"}</h2>
              </header>

              <ContainerDone>
                {loading ? (
                  <Lottie
                    options={defaultOptions}
                    height={400}
                    width={400}
                    style={{ backgroundColor: "red" }}
                  />
                ) : (
                  <>
                    <AnimatedDone size={150} />
                    <h3>Agora é só esperar os alunos se candidatarem.</h3>
                    <button onClick={() => history.replace("/empresa/vagas")}>
                      Ir para Vagas
                    </button>
                  </>
                )}
              </ContainerDone>
            </ContentEnviando>
          )}
        </>
      )}
      <h2 style={{ display: "flex", alignItems: "center" }}>
        <FaInfoCircle size={20} style={{ margin: 5, padding: 0 }} />
        Dicas
      </h2>
      <Dicas>
        <li>
          Você deve escolher uma área e ao menos um curso, os outros campos são
          opcionais.
        </li>
        <li>
          Clique em enviar quando sentir que a quantidade de alunos atinge suas
          espectativas.
        </li>
        <li>
          Os alunos contemplados por esse filtro receberão uma notificação.
        </li>
        <li>
          Você poderá reaplicar esse filtro com outras opções quando desejar.
        </li>
      </Dicas>
    </Container>
  );
}

const TagCurso = ({ handlerClose, obj }) => {
  let infoAbrev =
    obj.nome.length > 40
      ? obj.nome.substr(0, 40) + "... | C.H.: " + obj.carga_horaria
      : obj.nome + " | C.H.: " + obj.carga_horaria;

  return (
    <StyledTag alt={obj.nome}>
      {infoAbrev}
      <span
        onClick={() => {
          handlerClose(obj);
        }}
      >
        &times;
      </span>
    </StyledTag>
  );
};

const TagMunicipio = ({ obj, handlerClose }) => {
  return (
    <StyledTag alt={obj.municipio}>
      {obj.municipio}
      <span
        onClick={() => {
          handlerClose(obj);
        }}
      >
        &times;
      </span>
    </StyledTag>
  );
};

export default BuscarAlunos;
